import React from 'react';
import cx from 'classnames';

import { GradientDot, IconCaret } from '../..';

interface Props {
    addClasses?: string;
    gradientColor: GradientColor;
    handleClick?(): void;
    iconColor: string;
    width?: number;
}

export const PlayButton = ({
    addClasses,
    gradientColor,
    iconColor,
    width = 24,
    handleClick,
}: Props): JSX.Element => {
    const iconWidth = Math.floor(width * (2 / 3));

    return (
        <button
            className={cx('respond-to-mouse', addClasses)}
            type="button"
            onClick={(): void => {
                if (handleClick) {
                    handleClick();
                }
            }}
        >
            <GradientDot width={width} gradientColor={gradientColor}>
                <IconCaret
                    fillColor={iconColor}
                    rotation={-90}
                    width={iconWidth}
                />
            </GradientDot>
        </button>
    );
};
